import { fetchFromObject } from 'helpers/object';

export default {
  data: state => field => fetchFromObject(state, field),

  hasCampsMasterData: state =>
    !!state.storageParks &&
    !!state.states &&
    !!state.subStates &&
    !!state.categories &&
    !!state.taskStatus
};
